import React from 'react';
import classnames from 'classnames';
import { useHtmlIDs } from 'hellospa/common/hooks';
import { RadioField } from 'hellospa/components/editor/types';
import styles from './checkbox.scss';
import RadioIcon from 'hellospa/icons/radio-button';
import { signatureRequestContext } from '../context';


export type Props = {
  fieldData: RadioField,
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string,
  onKeyPress?: (event: React.KeyboardEvent<HTMLLabelElement>) => void,
  onTouchEnd?: (event: React.TouchEvent<HTMLLabelElement>) => void,
}

function RadioButton(
  { fieldData, onChange, className, onKeyPress, onTouchEnd }: Props,
  ref: React.Ref<any>,
) {
  const htmlId = useHtmlIDs();
  const context = React.useContext(signatureRequestContext);

  return (
    <React.Fragment>
      <input
        type="radio"
        id={htmlId('checkbox')}
        name={fieldData.group}
        value={fieldData.id}
        onChange={onChange}
        checked={fieldData.checked || false}
        className={styles.input} />
      <label
        className={classnames(styles.radioLabel, className)}
        htmlFor={htmlId('checkbox')}
        ref={ref}
        tabIndex={fieldData.readOnly ? -1 : 0}
        onKeyPress={onKeyPress}
        onTouchEnd={onTouchEnd}
      >
        <RadioIcon
          className={styles.radio}
          checked={fieldData.checked || false}
          isOverlay={context.isOverlay || false} />
      </label>
    </React.Fragment>
  );

}

export default React.memo(React.forwardRef(RadioButton));
